import { render, staticRenderFns } from "./trainingsHubExerciseExplorer.vue?vue&type=template&id=b0e6e246&scoped=true"
import script from "./trainingsHubExerciseExplorer.vue?vue&type=script&lang=js"
export * from "./trainingsHubExerciseExplorer.vue?vue&type=script&lang=js"
import style0 from "./trainingsHubExerciseExplorer.vue?vue&type=style&index=0&id=b0e6e246&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0e6e246",
  null
  
)

export default component.exports